import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useLoungeMaintenanceMode } from '../hooks/useLoungeMaintenanceMode';
import { isLoungeMaintenancePath } from '../utils/loungeMaintenance';
import LoungeMaintenanceScreen from './LoungeMaintenanceScreen';

type LoungeMaintenanceGateProps = {
  children: ReactNode;
};

export function LoungeMaintenanceGate({ children }: LoungeMaintenanceGateProps) {
  const location = useLocation();
  const shouldCheck = isLoungeMaintenancePath(location.pathname);
  const { config } = useLoungeMaintenanceMode(shouldCheck);

  if (!shouldCheck) {
    return <>{children}</>;
  }

  if (config.enabled) {
    return <LoungeMaintenanceScreen config={config} />;
  }

  return <>{children}</>;
}

export default LoungeMaintenanceGate;
